import { DateTime } from 'luxon';
import getTimeZone from './getTimeZone';
import { isUndefined } from 'lodash';

function getTimeZoneSpecificDate(dateUTC, timezone = 'Europe/Amsterdam', returnTime = true) {
  if (!dateUTC || isUndefined(dateUTC) || dateUTC === 'N/A') {
    return 'N/A';
  }

  if (typeof dateUTC !== 'number') {
    if (dateUTC?.toString()?.indexOf('(Coordinated Universal Time)') !== -1) {
      dateUTC = new Date(dateUTC);
      dateUTC = dateUTC?.toISOString();
    }
  }

  if (typeof dateUTC === 'number') {
    dateUTC = DateTime.fromMillis(dateUTC).toISO();
  } else {
    dateUTC = dateUTC
      ? `${dateUTC.replace(' ', 'T').slice(0, 19)}.000Z`
      : dateUTC;
  }

  const timeZone = getTimeZone() || timezone;

  return dateUTC?.length > 0 ? DateTime.fromISO(dateUTC, { zone: 'utc' })
    .setZone(timeZone)
    .toFormat(returnTime ? 'dd LLL, yyyy HH:mm:ss' : 'dd LLL, yyyy') : 'N/A';
}

export default getTimeZoneSpecificDate;
